import { Injectable } from '@angular/core';
import { Answers, Product } from '../models/response';
import { ImageOption, Options } from '../models/chat';
import { searchProduct } from '../models/search-product';

interface answerOptions {
  answers: string[],
  imageOptions: ImageOption[],
  multipleselectOptions: Options[]
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  searchProducts: searchProduct[] = [];

  transformMessage(answers: Answers[], questionType: string, messageType: string, products: Product[], productIds: string[]) {
    this.searchProducts = [];
    if (answers[0] && answers[0].image_category.length > 0) {
      questionType = "image_options";
    }
    const answerOptions = this.getAnswerOptions(questionType, answers);
    if (messageType === 'recommendations' && productIds.length > 0) {
      this.searchProducts = products.map((value: Product) => ({ selected: false, product: value }));
    }
    const transformedMessage = { sender: 'bot', feedback: 'None', answers: answerOptions.answers, answerSelected: false, products: this.searchProducts, additionalFeedbackFlag: false, questionType: questionType, multiselectOptions: answerOptions.multipleselectOptions, selectedMultiselectOptions: [], imageOptions: answerOptions.imageOptions };
    return transformedMessage;
  }

  getAnswerOptions(questionType:string, answers: Answers[]){
    const answerOptions:answerOptions = {
      answers: [],
      imageOptions: [],
      multipleselectOptions: []
    };
    if (questionType === 'multiple_select') {
      answerOptions.multipleselectOptions = this.getMultiSelectOptions(answers);
    } else if (questionType === 'image_options') {
      answerOptions.imageOptions = this.getImageOptions(answers);
    } else if (questionType === 'multiple_choice') {
      answerOptions.answers = this.getMultipleChoiceOptions(answers);
    }
    return answerOptions;
  }

  getMultiSelectOptions(answers: Answers[]){
    return answers.map((answer: Answers) => ({ name: answer.display_text + " " + answer.helper_text, flag: false }));
  }

  getImageOptions(answers: Answers[]){
    return answers.map((answer: Answers) => ({ key: answer.key, name: answer.display_text + " " + answer.helper_text, imageCategory: answer.image_category }));
  }

  getMultipleChoiceOptions(answers: Answers[]){
    return answers.map((answer: Answers) => answer.display_text + " " + answer.helper_text);
  }

  getProductIds(product:searchProduct[]):string[]{
    const productIds:string[] = product.map((product:searchProduct) => product.product.id || '');
    return productIds;
  }

}
